import * as React from "react";

import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import analytics from "services/analytics";
import { AnalyticsEvents } from "shared/constants/analytics";

import { styles } from "./styles";

interface MediaCardProps {
  source: string;
  logo: React.ReactNode;
  title: string;
  link: string;
}

const MediaCard: React.FC<MediaCardProps> = (props) => {
  const { source, logo, title, link } = props;

  const onReadArticleClick = () => {
    analytics().sendConversionEvent(
      AnalyticsEvents.iban_oplata_media_read_article,
      { source },
      true,
    );
  };

  return (
    <Stack direction={{ xs: "column", sm: "row" }} sx={styles.card}>
      <Box sx={styles.logoWrapper}>{logo}</Box>
      <Stack sx={styles.content}>
        <Typography variant="subtitle1" color="text.secondary">
          {source}
        </Typography>
        <Typography variant="h3" color="text.secondary" sx={styles.title}>
          {title}
        </Typography>
        <Link
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          variant="body1"
          color="text.secondary"
          onClick={onReadArticleClick}
        >
          Читати статтю
        </Link>
      </Stack>
    </Stack>
  );
};

export default MediaCard;
